
export const isGcsScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "gcs";

const RESPONSE_KEYS = [
  "eye_opening_response",
  "verbal_response",
  "motor_response",
];

export const hasGcsAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  for (const k of RESPONSE_KEYS) {
    const v = data[k];
    if (v == null || v === "") continue;
    const n = typeof v === "number" ? v : Number(v);
    if (Number.isFinite(n) && n > 0) return true;
  }

  return false;
};

